import type { CommissionLedgerEntry } from '../../../domain/entities/CommissionLedgerEntry';
import { formatNumber } from '../../../domain/formatters/date';
import type { SupportedLocale } from '../../../domain/formatters/currency';

type T = (key: string, vars?: Record<string, string | number>) => string;

/** "Booking commission", "Installment #14", or plain "Installment commission" when the number is unknown (0). */
export function typeLabel(
  entry: Pick<CommissionLedgerEntry, 'poolType' | 'installmentNumber'>,
  t: T,
  locale: SupportedLocale = 'en',
): string {
  if (entry.poolType === 'BOOKING_POOL') return t('commissions.booking');
  return entry.installmentNumber > 0
    ? t('commissions.installmentNo', { n: formatNumber(entry.installmentNumber, locale) })
    : t('commissions.installment');
}
